<div class="container">
  <div class="header">
    <div class="linking-images">
      <img
        src="assets/images/Uber-Driver-App-logo.png"
        alt="Uber Logo"
        class="uber"
        />
      <img
        src="assets/images/link-icon.png"
        alt="Link Icon"
        class="link"
        />
      <img
        src="assets/images/octopus-logo-badge.png"
        alt="Octopus Logo"
        class="octopus"
        />
    </div>
  </div>

  <!--  If Uber profile connection is successful, show profile details  -->

  @if (showUberProfile) {
    <div class="profile-container">
      <div class="profile-header">
        <h2>
          <img
            src="/assets/images/success-check.png"
            alt="Success Check"
            />
          Connection Successful!
        </h2>
      </div>
      <div class="profile-details">
        <div class="profile-image">
          <img src="{{ uberProfile?.picture }}" alt="Profile" />
        </div>
        <div class="profile-info">
          <div class="profile-name">
            <span
              >{{ uberProfile?.first_name }}
              {{ uberProfile?.last_name }}</span
              >
            </div>
            <div class="profile-email">
              <span>{{ uberProfile?.email }}</span>
            </div>
            <div class="profile-phone">
              <span>{{ uberProfile?.phone_number }}</span>
            </div>
          </div>
        </div>
        <div class="profile-actions">
          <p>
            Redirecting you to the
            {{ isApplication ? 'application' : 'dashboard' }} in
            <span>{{ countdown | i18nPlural : secondsMapping }}</span> or
            click the button below.
          </p>
          <button mat-raised-button color="accent" (click)="proceed()">
            Proceed to the {{ isApplication ? 'application' : 'dashboard' }}
          </button>
        </div>
      </div>
    }

    <!--  If Uber profile connection is not successful, show connection button  -->
    @if (!uberProfile && !isVerifying && !isUberConnectionSuccess) {
      <div
        class="unsuccessful-container"
        >
        <div class="unsuccessful-header">
          <h2>Error!</h2>
        </div>
        <div class="unsuccessful-content">
          <span>
            {{
            uberConnectionError ||
            'There was an error connecting your Uber account. Please try again.'
            }}
          </span>
          <uber-connect-button
            [uberConnectStatus]="'FAILED'"
            [showAlreadyConnected]="false"
            [connectedAccountPhone]="''"
            [loggedUserEmailDomain]="''"
            [isReferredByUberPartner]="isReferredByUberPartner$ | async"
          ></uber-connect-button>
          @if (shouldRedirect) {
            <p>
              Redirecting you to the
              {{ isApplication ? 'application' : 'dashboard' }} in
              <span>{{ countdown | i18nPlural : secondsMapping }}</span> or
              click the button below.
            </p>
          }
          @if (!shouldRedirect && !(isReferredByUberPartner$ | async)) {
            <p>
              Click the button below to proceed to the
              {{ isApplication ? 'application' : 'dashboard' }}.
            </p>
          }
          @if (!(isReferredByUberPartner$ | async)) {
            <button mat-raised-button color="accent" (click)="proceed()" id="uber-authorize-manual-proceed-button">
              Proceed to the {{ isApplication ? 'application' : 'dashboard' }}
            </button>
          }
        </div>
      </div>
    }

    <!--  If Uber code is being verified  -->
    @if (isVerifying) {
      <div class="verification-container">
        <div class="verification-header">
          <h2>Linking Your Uber Account</h2>
        </div>
        <div class="verification-details">
          <div class="verification-info">
            <mat-spinner diameter="21" color="primary"></mat-spinner>
            <span
              >Contacting Uber to link your account. Please do not refresh
              or hit back.</span
              >
            </div>
          </div>
        </div>
      }
    </div>
